import React from 'react';
import { CheckCircle2, XCircle, Combine, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Separator } from '../ui/separator';

export default function QueueToolbar({
  selectedCount,
  totalAmount,
  totalHours,
  onApprove,
  onReject,
  onMerge,
  actionLoading,
  totalItems
}) {
  const hasSelection = selectedCount > 0;

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" data-testid="queue-toolbar">
      <div className="flex items-center gap-3">
        <Badge variant="secondary" className="text-xs">
          {totalItems} item{totalItems !== 1 ? 's' : ''}
        </Badge>
        {hasSelection && (
          <>
            <Separator orientation="vertical" className="h-5" />
            <Badge className="bg-[hsl(var(--accent))] text-accent-foreground text-xs" data-testid="queue-selected-count-badge">
              {selectedCount} selected
            </Badge>
            <span className="text-xs text-muted-foreground" data-role="mono">
              {totalHours.toFixed(2)}h &middot; ${totalAmount.toFixed(2)}
            </span>
          </>
        )}
      </div>

      {hasSelection && (
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            onClick={onApprove}
            disabled={actionLoading !== null}
            className="bg-primary hover:bg-primary/90 text-primary-foreground transition-colors duration-150 active:scale-[0.98]"
            data-testid="queue-approve-selected-button"
          >
            {actionLoading === 'approve' ? (
              <Loader2 className="h-4 w-4 mr-1 animate-spin" />
            ) : (
              <CheckCircle2 className="h-4 w-4 mr-1" />
            )}
            Approve{selectedCount > 1 ? ` (${selectedCount})` : ''}
          </Button>

          <Button
            size="sm"
            variant="destructive"
            onClick={onReject}
            disabled={actionLoading !== null}
            className="transition-colors duration-150 active:scale-[0.98]"
            data-testid="queue-reject-selected-button"
          >
            {actionLoading === 'reject' ? (
              <Loader2 className="h-4 w-4 mr-1 animate-spin" />
            ) : (
              <XCircle className="h-4 w-4 mr-1" />
            )}
            Reject{selectedCount > 1 ? ` (${selectedCount})` : ''}
          </Button>

          {selectedCount >= 2 && (
            <Button
              size="sm"
              variant="outline"
              onClick={onMerge}
              disabled={actionLoading !== null}
              className="transition-colors duration-150 active:scale-[0.98]"
              data-testid="queue-merge-selected-button"
            >
              {actionLoading === 'merge' ? (
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              ) : (
                <Combine className="h-4 w-4 mr-1" />
              )}
              Merge
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
